import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import { formatDateTime } from '@/lib/format'
import { cn } from '@/lib/cn'
import { ALERT_STATUS_LABEL as STATUS_LABEL } from '../../types'
import type { StatusHistoryEntry, AlertStatus } from '../../types'

const STATUS_COLOR: Record<AlertStatus, string> = {
  open: 'bg-status-info',
  in_review: 'bg-status-pending',
  escalated: 'bg-priority-critical',
  merged: 'bg-muted-fg',
  closed: 'bg-muted-fg',
  closed_fraud: 'bg-priority-critical',
  closed_false_positive: 'bg-status-success',
  closed_duplicate: 'bg-muted-fg',
  closed_other: 'bg-muted-fg',
}

export function StatusHistoryTimeline({ history }: { history: StatusHistoryEntry[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Status history</CardTitle>
      </CardHeader>
      <CardContent>
        {history.length === 0 ? (
          <p className="text-sm text-muted-fg">No history yet.</p>
        ) : (
          <ol className="relative flex flex-col gap-3 border-l border-border pl-4">
            {history.map((entry) => (
              <li key={entry.id} className="relative">
                <span
                  aria-hidden
                  className={cn(
                    'absolute -left-[1.32rem] top-1.5 h-2 w-2 rounded-full ring-4 ring-card',
                    STATUS_COLOR[entry.to_status],
                  )}
                />
                <p className="text-sm">
                  <span className="font-medium">{STATUS_LABEL[entry.to_status]}</span>
                  {entry.from_status && (
                    <span className="text-muted-fg">
                      {' '}
                      from {STATUS_LABEL[entry.from_status]}
                    </span>
                  )}
                  {entry.by && (
                    <span className="text-muted-fg"> by {entry.by.display_name}</span>
                  )}
                </p>
                {entry.reason && (
                  <p className="mt-0.5 text-xs italic text-muted-fg">{entry.reason}</p>
                )}
                <p className="mt-0.5 text-xs text-muted-fg">{formatDateTime(entry.at)}</p>
              </li>
            ))}
          </ol>
        )}
      </CardContent>
    </Card>
  )
}
